import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api, { ContentProviderAccountDto } from 'api';
import { isAdmin } from '../../utils/userUtils';
interface AuthSliceState {
	userInfo: ContentProviderAccountDto | null;
	isAdmin: Boolean | null;
	tags: string[] | null;
}

const initialState: AuthSliceState = {
	userInfo: null,
	isAdmin: null,
	tags: ['initial-value'],
};

export const checkUserRole = createAsyncThunk('auth/checkUserRole', async (getIdTokenClaims: Function) => {
	return getIdTokenClaims();
});

export const updateUserAccountDetails = createAsyncThunk('auth/updateAccountDetails', async (data: any) => {
	return api.updateAccountDetails(data);
});

export const getUserInfo = createAsyncThunk('auth/getUserInfo', async () => {
	return api.getCPAccountDetails();
});

// export const getUserInfo = createAsyncThunk('auth/getUserInfo', async () => {
// 	return api.profile(userId);
// });

export const getUserTags = createAsyncThunk('auth/getUserTags', async (userId: string) => {
	return await api.profile(userId);
});

export const getTermsAndConditions = createAsyncThunk('auth/getLatestTermsAndConditions', async () => {
	return api.getLatestTermsAndConditions(false);
});
export const acceptTermsAndConditions = createAsyncThunk('auth/acceptTermsAndConditions', async () => {
	return api.acceptTermsAndConditions(undefined);
});
export const resendVerificationEmail = createAsyncThunk('auth/resendVerificationEmail', async () => {
	return api.resendVerificationEmail();
});

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getUserInfo.fulfilled, (state, action) => {
			state.userInfo = action.payload;
		});
		builder.addCase(getUserTags.fulfilled, (state, action) => {
			state.tags = action.payload.tags!;
		});
		builder.addCase(checkUserRole.fulfilled, (state, action) => {
			state.isAdmin = isAdmin(action.payload);
		});
	},
});

const { reducer } = authSlice;

export default reducer;
